import React from "react";
import "./About.css";
import About2 from "../../assets/about/about_1.jpg";
import AboutHero from "../../assets/about/about_hero.jpg";

const About: React.FC = () => {
  const coreValues = [
    {
      title: "WE ARE DEDICATED HOSTS",
      text: "We don't just arrange travels; we invite you into the heart of Bhutan, weaving each moment with care to leave you forever changed.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M3 10.5L12 4l9 6.5V21a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5H9v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-10.5z" />
        </svg>
      ),
    },
    {
      title: "PASSION DRIVES US",
      text: "Passion is our compass, guiding every step as we craft journeys that stir the soul and linger in the heart.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M12 2c2.6 3.1 4.2 5.8 4.2 8.6a4.2 4.2 0 1 1-8.4 0C7.8 7.8 9.4 5.1 12 2z" />
        </svg>
      ),
    },
    {
      title: "WE GENUINELY CARE",
      text: "True luxury is the quiet assurance of being deeply understood. We listen before you speak, anticipate before you ask, and walk beside you long before your journey begins.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
      ),
    },
    {
      title: "PURSUING EXCELLENCE",
      text: "Excellence is our baseline. We relentlessly elevate every aspect of your journey, transforming expectations into enduring memories.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <path d="M12 2l2.8 6.2 6.8.6-5.2 4.6 1.6 6.6L12 16.6 6 20l1.6-6.6L2.4 8.8l6.8-.6L12 2z" />
        </svg>
      ),
    },
    {
      title: "TEAMWORK OUR STRENGTH",
      text: "Perfection is a team effort. Our entire family of experts works in harmony to refine every moment of your journey, curating an experience that exceeds even your highest expectations.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="7.5" cy="8" r="2.5" />
          <circle cx="16.5" cy="8" r="2.5" />
          <path d="M3 19c0-2.8 2.4-4.5 4.5-4.5" />
          <path d="M21 19c0-2.8-2.4-4.5-4.5-4.5" />
          <path d="M8.5 13.5h7" />
        </svg>
      ),
    },
    {
      title: "WE ARE TRUE EXPERTS",
      text: "From secluded Himalayan monasteries to legendary fortresses, we've walked every path ourselves - your journey, enriched with the most authentic and extraordinary facets of Bhutan.",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          fill="none"
          stroke="black"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="9" />
          <path d="M14.5 9.5l-1.5 5-5 1.5 1.5-5 5-1.5z" />
        </svg>
      ),
    },
  ];

  return (
    <>
      <section className="about-section">
        <img src={AboutHero} alt="About Section" className="about-image" />
        <div className="about-overlay">
          <p>OUR STORY</p>
          <h2>Inspired by tradition, crafted with mastery.</h2>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section">
        <p className="vision-subtitle">THE ROOTS</p>
        <h1 className="vision-title">
          A SHARED VISION THAT BECAME A JOURNEY TO REVEAL BHUTAN’S SOUL.
        </h1>
      </section>

      {/* Inspiration Section */}
      <section className="inspiration-section">
        <div className="inspiration-content">
          <div className="inspiration-text">
            <p className="inspiration-subheading">BUILT ON INSPIRATION</p>
            <h2 className="inspiration-heading">
              FROM A COMMON LOVE TO DEFINING THE JOURNEY
            </h2>
            <p>
              After years of living and traveling across the globe, they each
              realized something profound: no one was truly capturing the
              essence of Bhutan in its truest form. The depth of its spiritual
              traditions, the grandeur of its Himalayan landscapes, and the
              genuine hospitality of its people were often missed by ordinary
              travel experiences.
            </p>
            <p>
              Leaving behind stable careers was a leap of faith, but the greater
              reward lay in building something extraordinary. What began as a
              vision evolved into one of the most respected travel agencies in
              the region-a journey to fulfill a gap for those desiring to see
              Bhutan. Even now, their passion inspires the team to craft
              journeys that transcend expectations.
            </p>
            <p>
              This is more than a business; it is a purpose. We are storytellers
              and guardians of Bhutan’s heritage, dedicated to revealing its
              hidden wonders with every journey we design.
            </p>
          </div>
          <div className="inspiration-image">
            <img src={About2} alt="Bhutan Reflection Scene" />
          </div>
        </div>
      </section>

      {/* Core Values Header */}
      <section className="vision-section">
        <p className="vision-subtitle">CORE VALUES</p>
        <h1 className="vision-title">Rooted in values, alive with passion.</h1>
      </section>

      {/* Core Values Grid */}
      <section className="core-values-section">
        <div className="core-values-grid">
          {coreValues.map((value) => (
            <div className="core-value-card" key={value.title}>
              <span className="core-icon">{value.icon}</span>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </div>
          ))}
        </div>
      </section>
      {/* <section className="vision-section">
        <p className="vision-subtitle">THE TEAM</p>
        <h1 className="vision-title">
          Not just a team. we are storytellers and guardians of Bhutan’s soul.
        </h1>
      </section> */}
    </>
  );
};

export default About;
